<template lang="html">
  <div class="panel panel-default chart-container">

    <!-- Chart Panel Header -->
    <div class="panel-heading text-center">

      <!-- Refresh Button -->
      <!-- <button class="btn btn-default btn-xs pull-left refresh-button"
              @click="refresh">
        <i class="fas fa-sync-alt"></i>
      </button> -->
      <!-- Refresh Button -->

      <!-- Chart Title -->
      <h5 class="chart-title" style="display: inline-block">{{ title }}</h5>
      <!-- Chart Title -->

      <!-- Export Chart Data Button -->
      <button class="btn btn-warning btn-sm pull-right export-button"
              data-toggle="tooltip"
              data-placement="top"
              title="Export this chart's data as CSV"
              v-if="this.$store.getters.filteredStats.length > 0"
              @click.stop="exportCSV(reportName)">
        <i class="fas fa-download"></i>
      </button>
      <!-- Export Chart Data Button -->

    </div>
    <!-- Chart Panel Header -->

    <!-- Chart Panel Body -->
    <div class="panel-body">
      <p class="text-center text-danger" v-if="errorBag.message">
        <i class="fas fa-exclamation-triangle"></i>
        <small>
          <strong>{{ errorBag.message }}</strong>
        </small>
      </p>
      <canvas width="420" height="200" ref="canvas"></canvas>
    </div>
    <!-- Chart Panel Body -->

    <!-- Chart Panel Footer -->
    <!-- <div class="panel-footer">
      <div class="text-muted text-center">
        <i class="fas fa-info-circle"></i>
        <small>{{ info }}</small>
      </div>
    </div> -->
    <!-- Chart Panel Footer -->
  </div>
</template>

<script>
import Vue from 'vue'
import Chart from 'chart.js'
import circleThru from 'circular-at' /** Allows for circular looping thru arrays */

export default Vue.extend({
  props: {
    'title': {
      type: String,
      required: true
    },
    'width': {
      type: String,
      default: '100'
    },
    'height': {
      type: String,
      default: '100'
    },
    'info': {
      type: String,
      required: true
    }
  },

  data () {
    return {
      errorBag: {},
      chartInstance: {},
      availableColors: {
        solid: [
          'rgba(218, 102, 94, 1.00)',  // Faded Red
          'rgba(139, 153, 105, 1.00)', // Faded Green
          'rgba(104, 155, 152, 1.00)', // Faded Teal
          'rgba(30, 37, 72, 1.00)',    // Navy Blue
          'rgba(255, 104, 0, 1.00)',   // Bright Orange
          'rgba(99, 106, 106, 1.00)',  // Light Grey
          'rgba(240, 189, 118, 1.00)', // Faded Yellow
          'rgba(231, 231, 236, 1.00)', // Off White
          'rgba(191, 78, 63, 1.00)',   // Red
          'rgba(142, 152, 110, 1.00)', // Green
          'rgba(114, 153, 151, 1.00)', // Teal
          'rgba(232, 159, 60, 1.00)',  // Yellow
          'rgba(39, 52, 91, 1.00)'     // New IPL Blue
        ],
        transparent: [
          'rgba(218, 102, 94, 0.80)',  // Faded Red - Transparent
          'rgba(139, 153, 105, 0.80)', // Faded Green - Transparent
          'rgba(104, 155, 152, 0.80)', // Faded Teal - Transparent
          'rgba(30, 37, 72, 0.80)',    // Navy Blue - Transparent
          'rgba(255, 104, 0, 0.80)',   // Bright Orange - Transparent
          'rgba(99, 106, 106, 0.80)',  // Light Grey - Transparent
          'rgba(240, 189, 118, 0.80)', // Faded Yellow - Transparent
          'rgba(231, 231, 236, 0.80)', // Off White - Transparent
          'rgba(191, 78, 63, 0.80)',   // Red - Transparent
          'rgba(142, 152, 110, 0.80)', // Green - Transparent
          'rgba(114, 153, 151, 0.80)', // Teal - Transparent
          'rgba(232, 159, 60, 0.80)',   // Yellow - Transparent
          'rgba(39, 52, 91, 1.00)'     // New IPL Blue - Transparent
        ]
      }
    }
  },

  computed: {
    reportName () {
      // eslint-disable-next-line
      return _.snakeCase(this.title)
    }
  },

  mounted () {
    /* eslint-disable */
    $(() => { $('[data-toggle="tooltip"]').tooltip() })
    /* eslint-enable */
  },

  methods: {
    /**
     * Renders the chart with the data provided.
     *
     * @param {Object} data The data required to create the chart.
     *
     * @return null
     */
    render (data) {
      let context = this.$refs.canvas.getContext('2d')
      Chart.defaults.global.defaultFontSize = 10
      this.chartInstance = new Chart(context, data)
    },

    /**
     * Refresh and redraw the chart.
     *
     * @returns null
     */
    refresh () {
      const vm = this
      // this should be a method on the Chart specific component for now
      vm.errorCheck()
      vm.chartInstance.destroy()

      vm.$nextTick(() => {
        vm.render(vm.chartData)
      })

      vm.$forceUpdate()
    },

    /**
     * Circles thru available colors and returns the required number of them.
     *
     * @param {String} type    Type of colors you want. Can except 'solid' / 'transparent'.
     * @param {Number} howMany The number of colors you want.
     *
     * @returns {Array}
     */
    getColors (type = 'solid', howMany = 10) {
      // eslint-disable-next-line
      if (!_.isString(type) || !_.isNumber(howMany)) {
        throw new TypeError('Please pass in a String as the first and a Number as the second argument.')
      } else {
        let colors = []
        for (let i = 0; i < howMany; i++) {
          colors.push(circleThru(this.availableColors[type], i))
        }
        return colors
      }
    },

    exportCSV (reportName) {
      this.eventHub.$emit('exportCSV', reportName)
    }
  }
})
</script>

<style lang="scss">
.chart-component {
  text-align: center;
}

button.refresh-button {
  display: inline !important;
}

button.export-button {
  display: inline !important;
  background-color: rgba(255, 104, 0, 0.90) !important;
  border: 1px solid rgba(255, 104, 0, 1.00) !important;
}

button.export-button {
  display: none !important;
}

.chart-container canvas {
  max-width: 420px;
  max-height: 200px;
}

.chart-container .panel-footer {
  display: none;
}

.chart-container.panel {
  border: none;
  border-radius: 0px;

  .panel-heading, .panel-body {
    border: none;
    border-radius: 0px;
  }

  .panel-heading {
    background-color: #fafafa;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/charts/BaseChart.vue